import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../../hooks';
import { Grid, LinearProgress, Typography } from '@mui/material';
import {
  IQuickStartObject,
  ToggleOption
} from '../../../../types/landing-api-response.model';
import ToggleButtonGroupWithIcon from '../../section-1/toggle-button-group';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import './quick-start.scss';
import { quick_start_data } from './dummydata';
import UserProfile from './user-profile';
import UserCategory from './user-category';
import {
  getQuickStartUserCategoryData,
  getQuickStartUserProfileData
} from '../../../../store/landing-slice';
import Storage from 'src/utils/storage/storage';
import LoaderOrNoData from '../loader-or-nodata';

export default function QuickStartComponent() {
  const appDispatch = useAppDispatch();

  const {
    isUserProfileDataFetching,
    userProfileData,
    isUserCategoryDataFetching,
    userCategoryData
  } = useAppSelector((state) => state.landing);

  //getting the source id from storage
  const { source: sourceId } = Storage.getSourceId();
  // deep cloning quick start data
  let quickStartData: IQuickStartObject[] = JSON.parse(
    JSON.stringify(quick_start_data)
  );

  const [selectedTab, setSelectedTab] = useState('user_profile');

  const toggles: ToggleOption[] = [
    {
      label: 'View by User Profile',
      value: 'user_profile',
      icon: <PersonOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
    },
    {
      label: 'View by category',
      value: 'category',
      icon: <MenuOutlinedIcon sx={{ fontSize: '16px' }} />
    }
  ];

  const handleToggleChange = (value: unknown) => {
    setSelectedTab(value as string);
  };

  // use effect for calling user profile & user category data
  useEffect(() => {
    appDispatch(getQuickStartUserProfileData({ sourceId }));
    appDispatch(getQuickStartUserCategoryData({ sourceId }));
  }, []);

  return (
    <Grid container className='quick-start-component' sx={{ height: '95%' }}>
      <Typography className='quick-start-desc'>
        Easily toggle between personalized and general views for a tailored
        experience. Customize your settings to match your unique preferences.
      </Typography>
      {/* div with rounded border */}
      <div className='parent-container'>
        <ToggleButtonGroupWithIcon
          onToggle={handleToggleChange}
          toggleValue={selectedTab}
          toggles={toggles}
          customClass='toggl-group-custom-class'
        />
        {selectedTab === 'user_profile' ? (
          isUserProfileDataFetching ? (
            <LoaderOrNoData type='loader' />
          ) : userProfileData?.length > 0 ? (
            <UserProfile profileData={userProfileData} />
          ) : (
            <LoaderOrNoData type='no-data' />
          )
        ) : isUserCategoryDataFetching ? (
          <LoaderOrNoData type='loader' />
        ) : userCategoryData?.length > 0 ? (
          <UserCategory categoryData={userCategoryData} />
        ) : (
          <LoaderOrNoData type='no-data' />
        )}
      </div>
    </Grid>
  );
}
